var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgProject24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.4C17.7438 22.4 22.4 17.7437 22.4 12C22.4 6.25621 17.7438 1.59998 12 1.59998C6.25624 1.59998 1.60001 6.25621 1.60001 12C1.60001 17.7437 6.25624 22.4 12 22.4Z",
    fill: "#F4F4F4",
    stroke: "#F4F4F4",
    strokeWidth: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2171_88374)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.75H12C11.586 6.75041 11.2504 7.08596 11.25 7.5V11.25H7.5C7.08596 11.2504 6.75041 11.586 6.75 12V17.25H17.25V7.5C17.2496 7.08596 16.914 6.75041 16.5 6.75ZM9.375 16.5V13.875H10.875V16.5H9.375ZM16.5 16.5H11.625V13.5C11.625 13.2929 11.4571 13.125 11.25 13.125H9C8.79289 13.125 8.625 13.2929 8.625 13.5V16.5H7.5V12H12V7.5H16.5V16.5ZM12.75 9H13.5V9.75H12.75V9ZM15 9H15.75V9.75H15V9ZM12.75 11.25H13.5V12H12.75V11.25ZM15 11.25H15.75V12H15V11.25ZM12.75 13.5H13.5V14.25H12.75V13.5ZM15 13.5H15.75V14.25H15V13.5Z",
    fill: "#CACACA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2171_88374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(6.75 6.75)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgProject24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/project-24.891240f9ff8ed20be8a82769faae6430.svg";